// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.SVG = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.SVG = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var SVG = _exports.SVG = function SVG(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M7.07031 13.1399H7.91193C7.90483 12.4599 7.36328 12 6.51811 12C5.68714 12 5.08878 12.4528 5.09411 13.1293C5.09233 13.6815 5.4794 13.9922 6.10795 14.136L6.48793 14.2248C6.88743 14.3171 7.06676 14.4254 7.07031 14.6296C7.06676 14.8516 6.85902 15.006 6.50568 15.006C6.11683 15.006 5.86115 14.8249 5.84162 14.4751H5C5.01065 15.3256 5.60192 15.7322 6.51634 15.7322C7.42188 15.7322 7.9581 15.3221 7.96165 14.6314C7.9581 14.0508 7.5657 13.6957 6.84837 13.5376L6.53587 13.4666C6.20561 13.3956 5.99609 13.2855 6.0032 13.0689C6.00497 12.87 6.17543 12.7262 6.51634 12.7262C6.85902 12.7262 7.04723 12.8807 7.07031 13.1399Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.23118 12.0497H8.24751L9.47443 15.6861H10.6445L11.8714 12.0497H10.8878L10.0746 14.7131H10.0444L9.23118 12.0497Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.4345 13.2376H15.324C15.2353 12.5131 14.589 12 13.7473 12C12.7761 12 12.0091 12.6836 12.0091 13.8732C12.0091 15.0238 12.7157 15.7358 13.758 15.7358C14.6937 15.7358 15.3631 15.1552 15.3631 14.1786V13.6974H13.7953V14.3384H14.5162C14.5073 14.7219 14.2409 14.9652 13.7651 14.9652C13.22 14.9652 12.9057 14.5621 12.9057 13.8626C12.9057 13.1683 13.2377 12.7706 13.7651 12.7706C14.1167 12.7706 14.3564 12.9428 14.4345 13.2376Z",
      fill: "#212B36"
    }));
  };
});
